module.exports = __webpack_public_path__ + "img/chevron-right.fdb8f4b7.svg";